module.exports = __webpack_public_path__ + "img/seaway_logo.8c16c4f4.png";